module.exports = __webpack_public_path__ + "static/img/y23-2.40ff8d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y23-2.png
// module id = 7ftO
// module chunks = 1